<template>
  <div :class="{'modal modal_wrap': modalView}">
    <div :class="{'modal_popup modal_content': modalView}">
      <div :class="{'modal__context': modalView}">
        <section class="item-types">
          <breadcrumbs v-if="!modalView && !isEdit"></breadcrumbs>
          <h2 class="titlePage_subtitle titlePage">WHEELS</h2>
          <span class="modal__close" v-if="modalView" @click="closePopup">
             <font-awesome-icon icon="times"/>
          </span>
          <div class="row">
            <div class="col-sm-6 col-md-4 col-12"
                 v-for="item in selection.groups.default.choices"
                 :key="item.id"
                 :id="`wheel-${kebabCase(item.name)}`"
                 v-if="item.is_default">
              <label class="form__label form__label_row">
                <input type="radio" hidden="hidden"
                       class="form__radio"
                       name="mesh"
                       v-bind:checked="item.default"
                       @change="selectOption(item)"
                >
                <span class="form__radio_icon"></span>
                <span class="form__labelTitle">{{item.name}}</span>
              </label>
            </div>

            <div class="col-sm-6 col-md-4 col-12"
                 v-for="item in selection.groups.default.choices"
                 :key="item.id"
                 :id="`wheel-${kebabCase(item.name)}`"
                 v-if="!item.is_default">
              <label class="form__label form__label_row">
                <input type="radio" hidden="hidden"
                       class="form__radio"
                       name="mesh"
                       @change="selectOption(item)"
                       v-bind:checked="item.default"
                >
                <span class="form__radio_icon"></span>
                <span class="form__labelTitle">{{item.name}}</span>
              </label>
            </div>
          </div>
          <template v-if="actionLinksPortalTarget">
            <portal :to="actionLinksPortalTarget">
              <button type="button" class="btn btn_transparent" v-if="!isUpdate" @click.prevent="next">next</button>
              <button type="button" class="btn btn_transparent" v-else @click.prevent="next">done</button>
            </portal>
          </template>
          <template v-else>
            <button type="button" class="btn btn_default" v-if="!isUpdate" @click.prevent="next">next</button>
            <button type="button" class="btn btn_default" v-else @click.prevent="next">done</button>
          </template>
        </section>
      </div>
    </div>

    <div class="tw-hidden">
      <div ref="stepOneContainer" class="">
          <div class="tw-bg-secondary tw-px-10 tw-pt-10 tw-pb-5 tw-rounded-3xl">
              <div class="tw-text-secondary tw-bg-white tw-rounded-lg tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica tw-px-5 tw-py-5">
                  <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                      {{ currentPath.wheelTitle }}
                  </h2>
                  <p v-html="currentPath.wheelDescription"></p>
              </div>

              <div class="tw-mt-4 tw-flex tw-space-x-4">   
                  <button @click="goBackToPrevScreen" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                      <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                  </button>

                  <button @click="nextStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                      <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                  </button>
              </div>
          </div>
          
      </div>

      <div ref="stepTwoContainer" class="tw-flex tw-space-x-2 ">
        <button @click="backStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer tw-bg-black tw-bg-opacity-40">
          <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
        </button>
        <button @click="goNextScreen" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer tw-bg-black tw-bg-opacity-40">
          <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  const breadcrumbs = () => import("./../../parts/breadcrumbs");
  import {calcSimpleOptionPrice} from "../../../helpers/calcPriceOption";
  import {changePriceForm} from "../../../helpers/aroundPrice";
  import {mapState, mapGetters} from 'vuex';
  import Modal from '@/components/modals/Generic'

  export default {
      name: "Wheel",
      data() {
          return {
              selection: {},
          }
      },
      components: {
          breadcrumbs, Modal,
      },
      props: ['options', 'package', 'set', 'checkIsSetPackage', 'actionLinksPortalTarget', 'backStepInCreate'],
      mounted() {
        this.$store.dispatch('demoWizard/delayTransition').then(() => {
          this.startTour()
        })
        
      },
      beforeDestroy() {
        if(this.tour) this.tour.complete()
      },
      methods: {
          kebabCase(val) {
              return _.kebabCase(val)
          },
          goBackToPrevScreen() {
              this.backStepInCreate()
          },
          backStep() {
              this.tour.back()
          },
          goNextScreen() {
              this.next()
          },
          nextStep() {
              this.tour.next()
          },
          startTour() {
            if(this.tour) this.tour.complete()
                this.$nextTick(() => {
                    this.tour = this.$shepherd({
                    exitOnEsc: false,
                    useModalOverlay: true,
                    modalOverlayOpeningPadding: 55,
                    arrow: false,
                    // stepsContainer: this.$refs.containerRef,
                    defaultStepOptions: {
                        classes: 'shepherd-theme-custom',
                        arrow: false,
                        modalOverlayOpeningRadius: 10,
                        modalOverlayOpeningPadding: 10, 
                        popperOptions: {
                        modifiers: [{ name: 'offset', options: { offset: [0, 30, ]} }]
                        },
                    }
                    });

                    this.tour.addStep({
                        text: this.$refs.stepOneContainer,
                        classes: 'shepherd-theme-custom width-full',
                    });

                    this.tour.addStep({
                        attachTo: { element: document.querySelector(`#wheel-${this.currentPath.wheelSelection}`), on: 'bottom-end' },
                        text: this.$refs.stepTwoContainer,
                        modalOverlayOpeningPadding: 5, 
                    });

                    this.tour.addStep({
                        attachTo: { element: document.querySelector(`#wheel-${this.currentPath.wheelSelection}`), on: 'top' },
                        text: this.$refs.stepFourContainer,
                    });

                    this.tour.start();
            });
          },
          selectOption(item) {
              const backup = _.cloneDeep(this.$store.getters['orderPosition/getCurrentOptionSettings']);

              _.forEach(this.selection.groups.default.choices, (i, k) => {
                  i.default = item.name == i.name;
              });

              if(this.isEdit) {
                  // const backup = _.cloneDeep(this.selection)
                  const rollbackHandler = () => {
                      this.$store.commit('orderPosition/setOption', {
                          option: 'WHL',
                          selection: backup
                      });
                  }
                  this.$store.dispatch('orderPosition/trackChanges', rollbackHandler)
              }

              this.$store.commit('orderPosition/setOption', {option: 'WHL', selection: this.selection});
          },

          next() {
              if(this.isEdit){
                  const backup = _.cloneDeep(this.$store.getters['orderPosition/getCurrentOptionSettings']);
                  const rollbackHandler = () => {
                      this.$store.commit('orderPosition/setOption', {
                          option: 'WHL',
                          selection: backup
                      });
                  }
                  this.$store.dispatch('orderPosition/guessNextStep', rollbackHandler)
              }else {
                  this.$store.commit('orderPosition/optionNext', 'WHL');
              }
              // this.$store.commit('orderPosition/optionNext', 'WHL');

          },
      closePopup() {
        this.$store.commit('options/closeAvailable');
      },
    },
    computed: {
      ...mapState('options', ['name', 'price', 'modalView', 'priceAllOptions']),
      ...mapState('orderItem', ['isUpdate']),
      ...mapGetters({
        isEdit: 'orderPosition/isCompleted',
      }),
      currentPath() {
        return this.$store.state['demoWizard'].currentPath
      }

    },

    created() {
        this.selection = this.$store.getters['orderPosition/getCurrentOptionSettings'];
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../assets/scss/utils/vars";

  .form {
    &__label {
      margin-top: 0;
      margin-bottom: 20px;
    }

    &__input {
      border: none;
      border-bottom: 2px solid $navy;
    }

    &__labelTitle {
      color: $navy;
    }
  }

  .text_white {
    position: absolute;
    bottom: 3rem;
    left: auto;
    right: 2rem;
    display: inline-block;
    width: auto;
  }

  .modal__close {
    color: $green;
  }
</style>
